import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TablePagination,
} from "@mui/material";
import { useMemo } from "react";
import { Employee } from "src/api/types";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import { LIMIT, PAGE } from "src/constants/searchParams";
import { useBatchFilters } from "src/hooks/useBatchFilters";
import { useFilters } from "src/hooks/useFilters";
import TableHeaderCell from "src/shared/TableHeaderCell";
import EmployeesTableRow from "../EmployeesTableRow";
import { columns } from "../../utils/columns";

interface Props {
  employees: Employee[];
  total: number;
}

const EmployeesTable = ({ employees, total }: Props) => {
  const [limit] = useFilters(LIMIT, ROWS_PER_PAGE[0].toString());
  const [page, setPage] = useFilters(PAGE, "0");
  const batchUpdate = useBatchFilters();

  //104 header + filters
  //64 gaps
  //34 top and bottom padding
  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage.toString());
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    batchUpdate((p) => {
      p.set(LIMIT, event.target.value);
      p.set(PAGE, "0");
      return p;
    });
  };

  return (
    <Box>
      <TableContainer sx={{ height: height - 52 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableHeaderCell key={column.id} column={column} />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((row) => (
              <EmployeesTableRow key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ height: 52, mr: 10 }}
        rowsPerPageOptions={ROWS_PER_PAGE}
        component="div"
        count={total}
        rowsPerPage={Number(limit)}
        page={Number(page)}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default EmployeesTable;
